/**
 * Our facade on top of graphql helpers|libraries\etc.
 * Small note, polygraphql is important, as graphql was taken by the graphql library.
 *
 * We provide an index, so that users of the facade are non concerned with the inner structure.
 * We should only worry about:
 *  A: The provider
 *  B: Hooks and HOC components we export for use.
 */
import Provider from "./Provider";
import { useMutation, useQuery, useSubscription, UseQuery } from "./hooks";
import { Mutation, Query, Subscription } from "urql";

//Default for react.lazy
export default Provider;
//Urql alias for the generated methods.
export {
  useQuery,
  useMutation,
  useSubscription,
  Query,
  Mutation,
  Subscription
};
export * from "./exchanges";
export type UseQueryArgs<V> = UseQuery<V>;
